import React from 'react';
import { TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import VFText from '../VFText';

import styles from './Label.Styles';

const Label = ({
  title,
  placeHolders,
  onPress,
  textStyle,
  textAccessibilityLabel,
  allowFontScaling,
  secondLabelTestId,
  ...props
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      {...props}
      accessible={false}
      testID={FoundationTestKeys.labelTO}
    >
      <VFText
        i18nKey={title}
        placeHolders={placeHolders}
        style={[styles.textStyle, textStyle]}
        testKey={secondLabelTestId ?? FoundationTestKeys.labelText}
        allowFontScaling={allowFontScaling}
      />
    </TouchableOpacity>
  );
};

Label.defaultProps = {
  placeHolders: [],
};

Label.propTypes = {
  onPress: PropTypes.func,
  title: PropTypes.string.isRequired,
  textStyle: PropTypes.object,
  textAccessibilityLabel: PropTypes.string,
  secondLabelTestId: PropTypes.string,
  allowFontScaling: PropTypes.bool,
  placeHolders: PropTypes.array,
};

export default Label;
